export { default } from "./ReadingSkillSearchLink";
